<template>
<div class="content-page">
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <h4 class="page-title">방 관리</h4>
                    </div>
                </div>
            </div>
            <div class="row mb-2" v-if="kosiwonList.length > 0">
                <div class="col-auto">
                    <div class="form-floating">
                        <select class="form-select" style="padding-bottom: 0.125rem;" v-model="selectedKosiwon" @change="fetchRoom()">
                            <option v-for="(kosiwon, idx) in kosiwonList" :key="`kosiwon_${idx}`" :value="kosiwon">
                                {{ computedKosiwonName(kosiwon) }}
                            </option>
                        </select>
                        <label>고시원 목록</label>
                    </div>
                </div>
                <div class="col-auto" style="margin-top:0.6rem;">
                    <a class="btn btn-primary rounded-pill mb-3" @click="openModal()">
                        <i class="mdi mdi-plus"></i> 방 등록
                    </a>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3" v-if="paginatedRoom.length > 0">
                            <div class="col-xl-7 col-12 mb-2 mb-xl-0">
                                <h4>{{ computedKosiwonName(selectedKosiwon) }}</h4>
                            </div>
                            <div class="col-xl-2 col-4">
                                <select class="form-select" v-model="limit">
                                    <option v-for="(item, idx) in limitList" :key="`limit_${idx}`" :value="item.value">
                                        {{ item.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-xl-3 col-8">
                                <div class="input-group">
                                    <input type="search" class="form-control" placeholder="방 호실 입력" v-model="searchText" @keypress.enter="searchNotice()" autocomplete="off">
                                    <button class="input-group-text btn btn-primary" @click="searchNotice()">검색</button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-centered table-nowrap text-center mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th style="width: 150px;" @click="sortRoom()">
                                            방 호실&nbsp;<i class="mdi" :class="sort ? 'mdi-arrow-down' : 'mdi-arrow-up'"></i>
                                        </th>
                                        <th style="width: 150px;">성별 타입</th>
                                        <th style="width: 150px;">방 타입</th>
                                        <th style="width: 150px;">창문 타입</th>
                                        <th style="width: 150px;">월 임대료</th>
                                        <th style="width: 150px;">보증금</th>
                                        <th style="width: 150px;">월 관리비</th>
                                        <th style="width: 100px;">방 크기</th>
                                        <th style="width: 150px;">수정 / 복사 / 삭제</th>
                                    </tr>
                                </thead>
                                <tbody v-if="loading">
                                    <tr>
                                        <td colspan="10">
                                            <div class="spinner-border" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <template v-else>
                                    <tbody style="text-align:center;" v-if="kosiwonList.length <= 0">
                                        <tr>
                                            <td colspan="10" class="py-5">
                                                <div class="text-center">
                                                    <img src="assets/images/svg/file-searching.svg" height="140" alt="File not found Image">
                                                    <h3 class="mt-4">등록된 고시원이 존재하지 않습니다.</h3>
                                                    <p class="text-muted mt-3">실제 운영중이신 고시원을 등록해보세요!<br />체계화된 입실자 관리 서비스를 이용하실 수 있습니다.</p>
                                                    <button type="button" class="btn btn-outline-info fw-bold mt-1" @click="goToKosiwonList()">
                                                        고시원 등록하기
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <template v-else>
                                        <tbody v-if="paginatedRoom.length > 0 ">
                                            <tr v-for="(room, idx) in paginatedRoom" :key="`room_${idx}`" @click="openModal(room, false)">
                                                <td class="fw-bold">{{ room.name }}</td>
                                                <td v-html="safeHTML(computedSexType(room))"></td>
                                                <td v-html="safeHTML(computedRoomType(room))"></td>
                                                <td v-html="safeHTML(computedWindowType(room))"></td>
                                                <td>{{ computedNumber(room.price) }}</td>
                                                <td>{{ computedNumber(room.deposit) }}</td>
                                                <td>{{ computedNumber(room.maintenance_price) }}</td>
                                                <td>{{ computedRoomSize(room) }}</td>
                                                <td>
                                                    <button type="button" class="btn btn-sm btn-outline-primary font-13 me-1" @click.stop="openModal(room, false)">
                                                        <i class="mdi mdi-home-edit-outline"></i> 수정
                                                    </button>
                                                    <button type="button" class="btn btn-sm btn-outline-info font-13 me-1" @click.stop="openModal(room, true)">
                                                        <i class="mdi mdi-home-group"></i> 복사
                                                    </button>
                                                    <button type="button" class="btn btn-sm btn-outline-danger font-13" @click.stop="openDelModal(room)">
                                                        <i class="mdi mdi-home-minus-outline"></i> 삭제
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody style="text-align:center;" v-else>
                                            <tr>
                                                <td colspan="10" class="py-5">
                                                    <div class="text-center">
                                                        <img src="assets/images/svg/file-searching.svg" height="140" alt="File not found Image">
                                                        <h3 class="mt-4">{{ computedKosiwonName(selectedKosiwon) }} 지점에 등록 / 검색된 방이 존재하지 않습니다.</h3>
                                                        <p class="text-muted mt-3">실제 운영중이신 방을 등록해보세요!<br />체계화된 입실자 관리 서비스를 이용하실 수 있습니다.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </template>
                            </table>
                        </div>
                        <div class="row mt-2 float-end" style="margin-bottom: -20px;" v-if="totalPages > 1">
                            <ul class="pagination">
                                <li class="page-item" @click="prevPage()">
                                    <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                                        <span aria-hidden="true">&laquo;</span>
                                    </a>
                                </li>
                                <li class="page-item" v-for="page in totalPages" :key="page" :class="{'active' : currentPage === page}" @click="changePage(page)">
                                    <a class="page-link" href="javascript: void(0);">{{ page }}</a>
                                </li>
                                <li class="page-item" @click="nextPage()">
                                    <a class="page-link" href="javascript: void(0);" aria-label="Next">
                                        <span aria-hidden="true">&raquo;</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <RoomModal :kosiwon_name="computedKosiwonName(selectedKosiwon)" :kosiwon_deposit="selectedKosiwon.deposit" :room="room" :options="options" :sexType_options="sexType_options" :windowType_options="windowType_options" :roomType_options="roomType_options" :roomStatus="roomStatus" :isWideScreen="isWideScreen" @save-room="saveRoom" />

    <RoomDeleteConfirmModal :kosiwon_name="computedKosiwonName(selectedKosiwon)" :room_name="room.name" @del-room="delRoom" />
</div>
</template>

<script>
import {
    DATE_FORMAT
} from "@/config/date.js";

import common from "@/mixins/common.js";

import RoomModal from "@/components/modal/Room";
import RoomDeleteConfirmModal from "@/components/modal/RoomDeleteConfirm";

export default {
    components: {
        RoomModal,
        RoomDeleteConfirmModal
    },
    mixins: [
        common
    ],
    data() {
        return {
            DATE_FORMAT: DATE_FORMAT,
            loading: true,
            isWideScreen: false,

            sort: true,

            kosiwonList: [],

            roomStatus: {
                flag: "",
                headText: "",
                btnText: "",
            },

            roomList: [],
            room: {},

            currentPage: 1,

            limit: 1000,
            limitList: [{
                    text: "10개",
                    value: 10
                },
                {
                    text: "20개",
                    value: 20
                },
                {
                    text: "30개",
                    value: 30
                },
                {
                    text: "40개",
                    value: 40
                },
                {
                    text: "50개",
                    value: 50
                },
                {
                    text: "100개",
                    value: 100
                },
                {
                    text: "전체",
                    value: 1000
                },
            ],

            searchText: "",
            activeSearchText: "",

            init_room: {
                name: "",
                room_type: "O",
                room_size: "",
                window_type: "I",
                sex_type: "U",
                price: 0, // 30
                deposit: 0, // 10
                maintenance_price: 0,
                options: {
                    is_bed: false,
                    is_desk: false,
                    is_chair: false,
                    is_tv: false,
                    is_hanger: false,
                    is_closet: false,
                    is_cabinet: false,
                    is_fan: false,
                    is_internet: false,
                    is_restroom: false,
                    is_aircon: false,
                    is_refrigerator: false,
                    is_wash: false,
                    is_doorlock: false
                },
                images: [],
                memo: "",
                is_deleted: false
            },

            options: [{
                    value: "is_bed",
                    text: "침대",
                    checked: false
                },
                {
                    value: "is_desk",
                    text: "책상",
                    checked: false
                },
                {
                    value: "is_chair",
                    text: "의자",
                    checked: false
                },
                {
                    value: "is_tv",
                    text: "TV / 모니터",
                    checked: false
                },
                {
                    value: "is_hanger",
                    text: "행거",
                    checked: false
                },
                {
                    value: "is_closet",
                    text: "옷장",
                    checked: false
                },
                {
                    value: "is_cabinet",
                    text: "수납장",
                    checked: false
                },
                {
                    value: "is_fan",
                    text: "선풍기",
                    checked: false
                },
                {
                    value: "is_internet",
                    text: "인터넷(WI-FI)",
                    checked: false
                },
                {
                    value: "is_restroom",
                    text: "개별 화장실",
                    checked: false
                },
                {
                    value: "is_aircon",
                    text: "개별 에어컨",
                    checked: false
                },
                {
                    value: "is_refrigerator",
                    text: "개별 냉장고",
                    checked: false
                },
                {
                    value: "is_wash",
                    text: "개별 세탁기",
                    checked: false
                },
                {
                    value: "is_doorlock",
                    text: "개별 도어락",
                    checked: false
                }
            ],
            sexType_options: [{
                    value: "U",
                    text: "성별 무관",
                    checked: true
                },
                {
                    value: "M",
                    text: "남성 전용",
                    checked: false
                },
                {
                    value: "W",
                    text: "여성 전용",
                    checked: false
                }
            ],

            windowType_options: [{
                    value: "I",
                    text: "내창",
                    checked: true
                },
                {
                    value: "O",
                    text: "외창",
                    checked: false
                }
            ],
            roomType_options: [{
                    value: "O",
                    text: "원룸",
                    checked: true
                },
                {
                    value: "S",
                    text: "샤워룸",
                    checked: false
                },
                {
                    value: "M",
                    text: "미니룸",
                    checked: false
                },
                {
                    value: "D",
                    text: "2인실",
                    checked: false
                }
            ]
        }
    },
    beforeRouteLeave(to, from, next) {
        $(".modal").modal("hide");
        next();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.checkScreenWidth);
    },
    computed: {
        selectedKosiwon: {
            set(value) {
                this.$store.commit("SET_SELECTED_KOSIWON", value);
            },
            get() {
                return this.$store.state.selectedKosiwon;
            }
        },
        filterRoom() {
            return this.roomList.filter(room =>
                room.name.toLowerCase().includes(this.activeSearchText.toLowerCase())
            );
        },
        paginatedRoom() {
            const startIdx = (this.currentPage - 1) * this.limit;
            const endIdx = startIdx + this.limit;

            return this.filterRoom.slice(startIdx, endIdx);
        },
        totalPages() {
            return Math.ceil(this.filterRoom.length / this.limit);
        }
    },
    created() {
        this.room = {
            ...this.init_room
        };
    },
    async mounted() {
        try {
            const res = await this.axios.get("/kosiwon");

            this.kosiwonList = res.data.result;

            if (this.kosiwonList.length > 0) {
                this.$store.commit("SET_SELECTED_KOSIWON", this.selectedKosiwon.pk ? this.selectedKosiwon : this.kosiwonList[0]);
                this.fetchRoom();
            }

        } catch (error) {
            console.log(error);
        } finally {
            setTimeout(() => {
                this.checkScreenWidth();
                window.addEventListener("resize", this.checkScreenWidth);
                this.loading = false;
            }, 200);
        }
    },
    methods: {
        goToKosiwonList() {
            this.$router.push({
                path: "/kosiwon/list"
            });
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        changePage(page) {
            if (this.currentPage !== page) {
                this.currentPage = page;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        searchNotice() {
            this.activeSearchText = this.searchText;
            this.currentPage = 1;
        },
        checkScreenWidth() {
            this.isWideScreen = window.innerWidth >= 576;
        },
        computedKosiwonName(kosiwon) {
            return `${kosiwon.name} ${kosiwon.branch}`;
        },
        computedRoomSize(room) {
            return room.room_size ? `${room.room_size}㎡` : "-";
        },
        computedRoomType(room) {
            const type = this.roomType_options.find(type => type.value === room.room_type);

            const iconTemplate = (showerIcon, toiletIcon) =>
                `<i class="mdi mdi-shower-head"></i><i class="mdi mdi-${showerIcon}"></i> / 
                <i class="mdi mdi-toilet"></i><i class="mdi mdi-${toiletIcon}"></i>`;

            const badgeTemplate = (color, content) =>
                `<div class="badge ${color} p-2 font-12">
                    ${content}${type.text}
                </div>`;

            switch (type.value) {
                case "O": // 원룸
                    return badgeTemplate("badge-success-lighten", iconTemplate("check", "check"));
                case "S": // 샤워룸
                    return badgeTemplate("badge-info-lighten", iconTemplate("check", "close"));
                case "M": // 미니룸
                    return badgeTemplate("badge-primary-lighten", iconTemplate("close", "close"));
                case "D": // 2인실
                    return badgeTemplate("badge-secondary-lighten", "<i class='mdi mdi-bed-double-outline'></i>");
                default:
                    return "";
            }
        },
        computedWindowType(room) {
            const window = this.windowType_options.find(type => type.value === room.window_type);
            const icon = window.value === "I" ? "mdi-window-closed" : "mdi-window-open-variant";

            return `<div class="badge badge-secondary-lighten p-2 font-12">
                        <i class="mdi ${icon}"></i> ${window.text}
                    </div>`;
        },
        computedSexType(room) {
            const sex = this.sexType_options.find(type => type.value === room.sex_type);
            let color = "";
            let icon = "";

            switch (sex.value) {
                case "U": // 성별무관
                    color = "secondary";
                    icon = "mdi-human-male-female";
                    break;
                case "M": // 남성전용
                    color = "info";
                    icon = "mdi-human-male";
                    break;
                case "W": // 여성전용
                    color = "danger";
                    icon = "mdi-human-female";
                    break;
            }

            return `<div class="badge badge-${color}-lighten p-2 font-12">
                        <i class="mdi ${icon}"></i> ${sex.text}
                    </div>`;
        },
        computedNumber(num) {
            return num > 0 ? `${num}만원` : "없음";
        },
        sortRoom() {
            this.sort = !this.sort; // toggle

            // * a.localeCompare(b) -> a가 b보다 작으면 음수, 같으면 0, 크면 양수
            this.roomList.sort((a, b) => this.sort ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name));
        },
        setRoomAndStatus(room, isCopy) {
            if (room) {
                if (isCopy) {
                    this.room = {
                        ...room,
                        name: `${room.name}_복사본`
                    };
                    delete this.room.pk;
                    this.roomStatus = {
                        flag: "copy",
                        headText: "방 정보 복사",
                        btnText: "복사"
                    };
                } else {
                    this.room = {
                        ...room
                    };
                    this.roomStatus = {
                        flag: "edit",
                        headText: "방 정보 수정",
                        btnText: "수정"
                    };
                }
            } else {
                this.room = {
                    kosiwon_pk: this.selectedKosiwon.pk,
                    ...this.init_room
                };
                this.roomStatus = {
                    flag: "create",
                    headText: "방 추가",
                    btnText: "저장"
                };
            }
        },
        openModal(room = null, isCopy = false) {
            this.setRoomAndStatus(room, isCopy);
            $("#room-modal").modal("show");
        },
        openDelModal(room) {
            this.room = room;
            $("#room-delete-modal").modal("show");
        },
        async fetchRoom() {
            try {
                this.loading = true;

                const res = await this.axios.get(`/room?kosiwon_pk=${this.selectedKosiwon.pk}`);
                this.roomList = res.data.result;

                this.roomList.forEach(room => {
                    room.options = JSON.parse(room.options);
                    room.images = JSON.parse(room.images);
                });
            } catch (error) {
                console.log(error);
            } finally {
                setTimeout(() => {
                    this.loading = false;
                }, 200);
            }
        },
        async delRoom() {
            try {
                this.loadingOverlay(true);

                await this.axios.delete(`/room/${this.room.pk}`);
                alert("정상적으로 삭제가 완료 되었습니다");
            } catch (error) {
                console.log(error);
                alert("방 삭제 중 에러가 발생하였습니다.\n다시 시도해주세요.");
            } finally {
                this.loadingOverlay(false);
                this.$router.go();
            }
        },
        createPayload() {
            const payload = {
                ...this.room
            };

            payload.maintenance_price = payload.maintenance_price || 0;
            payload.deposit = payload.deposit || 0;

            payload.options = {};
            this.options.forEach(option => payload.options[option.value] = option.checked);

            payload.room_type = this.roomType_options.find(item => item.checked).value;
            payload.sex_type = this.sexType_options.find(item => item.checked).value;
            payload.window_type = this.windowType_options.find(item => item.checked).value;

            payload.options = JSON.stringify(payload.options);
            payload.images = JSON.stringify(payload.images);

            return payload;
        },
        setFocus(id) {
            document.getElementById(id).focus();
        },
        async saveRoom() {
            if (this.room.name.trim() === "") {
                alert("방 호실을 입력해주세요.");
                this.room.name = "";
                this.setFocus("name");
                return;
            }

            if (!/^[0-9]*$/.test(this.room.room_size)) {
                alert("방 크기는 숫자만 입력 가능합니다.");
                this.room.room_size = "";
                this.setFocus("room_size");
                return;
            }

            if (this.room.price === "" || this.room.price <= 0) {
                alert("월 임대료에 금액을 입력해주세요.\n0보다 커야합니다.");
                this.setFocus("price");
                return;
            }

            const checked_options = this.options.filter(item => item.checked);

            if (checked_options <= 0) {
                alert("방 옵션을 한 개 이상 선택해주세요.");
                return false;
            }

            try {
                this.loadingOverlay(true);

                const payload = this.createPayload();

                if (this.roomStatus.flag === "create") {
                    await this.axios.post("/room", payload);
                    alert("방 등록이 정상적으로 완료되었습니다.");
                } else if (this.roomStatus.flag === "copy") {
                    await this.axios.post("/room", payload);
                    alert("방 복사가 정상적으로 완료되었습니다.");
                } else if (this.roomStatus.flag === "edit") {
                    await this.axios.put(`/room/${payload.pk}`, payload);
                    alert("방 정보 수정이 정상적으로 완료되었습니다.");
                }
            } catch (error) {
                console.log(error);
                alert("방 등록 중 예기치 못한 에러가 발생하였습니다.\n다시 시도해주세요.");
            } finally {
                this.loadingOverlay(false);
                this.$router.go();
            }
        }
    }
}
</script>
